import * as React from 'react'
import autocomplete from 'autocomplete.js'
import statusActions from '../status/status-actions'
import fieldsActions from '../fields/fields-actions'
import { get } from 'lodash'

// Used in steps, call this after validation.validate but before calling the submission.submit action.
export const validateAddress = (success:()=>void, unitNumberField:string, streetNumberField:String, streetNameField:String, suburbField:String, stateField:String, postcodeField:String) => {
    return (dispatch, getState) => {
        const state = getState()
        
        
        // We are going to ignore validation, as a requested by a previous action
        if(state.addressValidation.ignoreErrors){
            // Check if the fields have updated. If they haven't updated, then we know to bail out
            // of the validation check
            if(
                get(state.fields, unitNumberField) == state.addressValidation.checkedUnit &&
                get(state.fields, streetNumberField) == state.addressValidation.checkedStreetNumber &&
                get(state.fields, streetNameField) == state.addressValidation.checkedStreetName &&
                get(state.fields, suburbField) == state.addressValidation.checkedSuburb
            ){
                dispatch((dispatch, getState) =>{
                    success()
                });
                return;
            }
        }

        console.log("Checking")
        // Save the current field values 
        dispatch( checkAgainstAddress(
            get(state.fields, unitNumberField), // save and dispatch unitfield to be displayed in the backend
            get(state.fields, streetNumberField),
            get(state.fields, streetNameField),
            get(state.fields, suburbField)
        ) )

        // Show the loading indicator
        dispatch( statusActions.showLoading("address validation") )
        
        // We are performing a new validation check, so we must clear out the old state from
        // the previous validation check
        dispatch(clearPotentialAddresses())
        
        // Perform an inline action using a thunk
        dispatch((dispatch, getState) => {
            
            const axios = state.addressValidation.axios
            const fields:Object = state.fields

            console.log("Street number field")
            console.log(streetNumberField)

            // Prepare the GET request query params
            var endpoint = state.addressValidation.endpoint
            var unitNumberValue = get(fields, unitNumberField)
            if(unitNumberValue === null || unitNumberValue === undefined || unitNumberValue === '') {
                endpoint += "?stNum=" + get(fields, streetNumberField).toUpperCase();
            } else {
                endpoint += "?unitNum=" + ("" + unitNumberValue).toUpperCase(); 
                endpoint += "&stNum=" +  get(fields, streetNumberField).toUpperCase();        
            }
            
            endpoint += "&stName=" + get(fields, streetNameField).toUpperCase();
            endpoint += "&suburb=" + get(fields, suburbField).toUpperCase();
            endpoint += "&state=" + get(fields, stateField).toUpperCase();
            endpoint += "&postcode=" + get(fields, postcodeField);

            axios.get(endpoint)
            .then(response => {

                // Hide the loading indicator
                dispatch( statusActions.hideLoading("validate address success") )
                
                // Address is invalid, and the potential matches are provided in the field
                // addresses.
                if(response.data.validAddress === false && response.data.addresses){
                    console.log("Address is invalid. Display potential matches")
                    const fields = {
                        unitNumber: unitNumberField,
                        streetNumber: streetNumberField,
                        streetName: streetNameField,
                        suburb: suburbField,
                        state: stateField,
                        postcode: postcodeField
                    }
                    dispatch(supplyPotentialAddresses(response.data.addresses, fields))
                
                // If the address is invalid but there are more than 250 potential addresses
                // there won't be an addresses object in the response, so we don't show
                // the address picker.
                }else if(response.data.validAddress === false && !response.data.addresses){
                    console.log("Address is invalid. Too many addresses to display")                  
                    // We are flagging that we are going to ignore the invalid address.
                    // fields.addressNotFound = true will be set
                    dispatch( ignoreAddresses() )

                    // Having flagged that we are ignoring the invalid address we are going
                    // to proccedd. The form step must pass addressNotFound in the next request!
                    dispatch((dispatch, getState) => success())

                // The address is valid.
                }else{
                    dispatch(succeedWithAddress())
                    dispatch((dispatch, getState) => success())
                }
            })

            // Handle error
            .catch(err => {
                console.log("ADDRESS VALIDATION ERROR")
                console.log(err)
                dispatch( statusActions.hideLoading("validate address error") )
                dispatch( statusActions.showMessage("Error", <span>Oops, something went wrong. If this error persists, please <a href='http://www.chu.com.au/contact-us/'>contact your local CHU office</a></span>, true) )
            })
        })
        
    }
}


const checkAgainstAddress = (unitNumber, streetNumber, streetName, suburb) => ({
    type: "CHECK_AGAINST_ADDRESS",
    unitNumber,
    streetNumber,
    streetName,
    suburb
})


const succeedWithAddress = () => ({
    type: "SUCCEED_WITH_ADDRESS"
})


const supplyPotentialAddresses = (addresses, fields) => ({
    type: "SUPPLY_POTENTIAL_ADDRESSES",
    addresses,
    fields
})

// Internal: Used by address-validation HOC to clear potentialAddresses
export const clearPotentialAddresses = () => ({
    type: "CLEAR_POTENTIAL_ADDRESSES"
})

// Internal: Used by address-validation HOC to ignore all provided addresses, to continue onward
export const ignoreAddresses = () => ({
    type: "IGNORE_ADDRESSES"
})

// Internal: Used by address-validation HOC to to select a new address
export const selectNewAddress = (address) =>{
    return (dispatch, getState) => {
        const state = getState()
        const fields = state.addressValidation.fields
        const fieldsData = {
            [fields.unitNumber]: address.deliveryPoint,
            [fields.streetNumber]: address.streetNumber,
            [fields.streetName]: address.streetName,
            [fields.suburb]: address.suburb,
            [fields.state]: address.state,
            [fields.postcode]: address.postcode
        }
        dispatch(fieldsActions.updateFields(fieldsData))
        dispatch(clearPotentialAddresses);
    }
}


export default {
    validateAddress,
    selectNewAddress,
    clearPotentialAddresses,
    ignoreAddresses
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/address-validation/address-validation-actions.tsx